import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=49cdb2cc&scoped=true&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cdb2cc",
  null
  
)

export default component.exports